import { combineReducers } from 'redux';
import { ActionType } from 'typesafe-actions';
import {
  WORLD_CUP_RANKINGS_FAILURE,
  WORLD_CUP_RANKINGS_REQUEST,
  WORLD_CUP_RANKINGS_SUCCESS,
} from '../../constants/worldCupRankings';
import { WorldCupRanking } from '../../types/WorldCupRankings';
import { worldCupRankingsActions } from './actions';

export type WorldCupRankingsState = {
  requested: boolean;
  data: WorldCupRanking;
  isLoading: boolean;
  error: string | null;
};
export type WorldCupRankingsActions = ActionType<
  typeof worldCupRankingsActions
>;

export const worldCupRankingsReducer = combineReducers<
  WorldCupRankingsState,
  WorldCupRankingsActions
>({
  requested: (state = false, action) => {
    switch (action.type) {
      case WORLD_CUP_RANKINGS_REQUEST:
        return true;
      default:
        return state;
    }
  },
  data: (state = [], action) => {
    switch (action.type) {
      case WORLD_CUP_RANKINGS_SUCCESS:
        return action.payload;
      default:
        return state;
    }
  },
  isLoading: (state = false, action) => {
    switch (action.type) {
      case WORLD_CUP_RANKINGS_REQUEST:
        return true;
      default:
        return false;
    }
  },
  error: (state = null, action) => {
    switch (action.type) {
      case WORLD_CUP_RANKINGS_FAILURE:
        return action.payload.message || action.payload.detail;
      default:
        return null;
    }
  },
});
